<template>
    <h3>Du er ikke logget ind!</h3>
    <p>Login nedenunder nu</p>
    <form @submit.prevent="login">
        <input required type="text" id="username" placeholder="Brugernavn" v-model="username">
        <input required type="password" id="password" placeholder="Adgangskode" suggested="current-password" v-model="password">
        <br>
        <label for="remember_me" class="remember-label">
            <input type="checkbox" v-model="checked" @change="this.persistence = this.checked ? 'long' : 'short'">
            <span>Husk mig</span>
        </label>
        <p v-if="errorMessage" class="error-message">{{  errorMessage }}</p>

        <button class="login">Login</button>
    </form>

    <br><br>
    <h3>Har du ikke en konto?</h3>
    <p>
        Opret en konto nu:
        <router-link to="/signup" class="signup">Tryk her</router-link>
    </p>
</template>

<script>
import axios from "axios"
import EventBus from "../eventBus.js"
import { useToast } from "vue-toastification"

const toast = useToast();

export default {
    name: "LoginForm",
    data() {
        return {
            checked: true,
            errorMessage: null,
            username: "",
            password: "",
            persistence: "short"
        }
    },
    methods: {
        async login() {
            const loginBody = {
                username: this.username,
                password: this.password,
                persistence: this.persistence
            };
            try {
                const response = await axios.post("/login", loginBody);
                if (response.status == 200) {
                    EventBus.emit("login-profile", {
                        profile: response.data.profile,
                        auth_token: response.data.authorization.token
                    });
                }
            } catch (error) {
                console.error(error)
                this.errorMessage = error.response.data.detail;
                if (this.errorMessage != "") {
                    toast.error(this.errorMessage);
                }
            } finally {
                this.submitting = false
            }
        },
        
        signup() {
            this.$router.push("/signup")
        }
    }
}

</script>

<style scoped>
    h3 {
        margin: 5px 0;
        font-size: 20px;
    }
    p, span {
        margin: 0;
        font-size: 18px;
        color: #2b2a2a;
    }
    .remember-label {
        display: flex;
        align-items: center;
        gap: 5px;
        justify-content: flex-start; 
        margin-top: 5px;
        margin-left: -3px;
    }
    input:not([type="checkbox"]) {
        font-size: 18px;
        margin-top: 5px;
        border-radius: 5px;
        padding: 10px;
        width: 100%;
        box-sizing: border-box;
        border: none;
        border-bottom: 1px solid #ddd;
        color: #555;
    }
    input {
        font-size: 18px;
    }
    .login {
        margin-top: 8px;
        border-radius: 15px;
        background-color: yellow;
        letter-spacing: 1px;
        font-size: 0.9em;
        color: #666;
        border: none;
        width: 80px;
        height: 35px;
        cursor: pointer;
        font-weight: bold
    }
    .login:hover {
        background-color: gold;
    }
    .signup {
        font-weight: bold;
        color: yellow;
        text-decoration: underline;
        cursor: pointer;
    }
    .signup:hover {
        color: gold
    }
    .error-message {
        color: rgb(158, 37, 37);
        margin-left: 0;
        padding: 0;
    }
</style>
